export default {
    search: {
      placeholder: 'جست‌جو برای...',
    },
    sort: {
      sortAsc: 'مرتب سازی صعودی',
      sortDesc: 'مرتب سازی نزولی',
    },
    pagination: {
      previous: 'قبلی',
      next: 'بعدی',
      navigate: (page, pages) => `صفحه ${page} از ${pages}`,
      page: (page) => `صفحه ${page}`,
      showing: 'نمایش',
      of: 'از',
      to: 'تا',
      results: 'نتایج',
    },
    loading: 'در حال دریافت...',
    noRecordsFound: 'نتیجه‌ای یافت نشد.',
    error: 'دریافت اطلاعات با خطا مواجه شد.',
  };